"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AttachmentPreview = AttachmentPreview;

var _react = _interopRequireDefault(require("react"));

var Elements = _interopRequireWildcard(require("../Comment.styles"));

var _blocks = require("@bueno/blocks");

var _regex = require("../../../../../utils/regex");

function AttachmentPreview({
  path,
  fileName
}) {
  if (_regex.matchImageFile.test(fileName)) {
    return /*#__PURE__*/_react.default.createElement(Elements.AttachmentListItem, null, /*#__PURE__*/_react.default.createElement(Elements.AttachmentLink, {
      href: path
    }, /*#__PURE__*/_react.default.createElement(Elements.AttachmentImage, {
      imgLink: path
    })));
  }

  return /*#__PURE__*/_react.default.createElement(Elements.NonImageAttachmentLink, {
    href: path
  }, /*#__PURE__*/_react.default.createElement(_blocks.FileText, {
    fillColor: _blocks.palette.blue7,
    small: true
  }), " ", fileName);
}